import type { Get_Campaigns_For_ExportQuery } from '../../../../apis/graphql';
import type { CampaignModel } from '../../TraffickingPage/modelConverters';
import { campaignNodeToModel } from '../../TraffickingPage/modelConverters';

export type CampaignNodeForExport = NonNullable<Get_Campaigns_For_ExportQuery['campaigns']['edges'][number]>['node'];

export type CampaignModelForExport = CampaignModel;

export const campaignNodeToModelForExport = (node: CampaignNodeForExport): CampaignModelForExport => {
  return campaignNodeToModel(node);
};
